import { ContractorPumpPriceCreate } from './ContractorPumpPrice.entity';

export const CONTRACTOR_PUMP_PRICE_CRATE: ContractorPumpPriceCreate = {
  contractorId: null,
  dateBegin: undefined,
  factoryId: null,
  objectId: null,
  price: null,
  minQuantity: null,
  pumpInnings: 0,
  pumpLen: null,
  pumpPriceMinimal: 0,
  downtime: 0,
  pumpMoving: 0,
  pumpPipes: 0,
  pumpQuencher: 0,
};
